import * as React from "react";
const SvgFiBrandsShopify = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-shopify_svg__a)">
      <path d="m15.865 2.8-.72.222a5 5 0 0 0-.343-.845c-.51-.972-1.255-1.486-2.156-1.487h-.003q-.093.002-.187.012a2 2 0 0 0-.081-.094c-.392-.42-.896-.625-1.5-.607-1.163.033-2.322.874-3.262 2.367-.662 1.05-1.164 2.37-1.307 3.392l-2.292.71c-.674.211-.695.232-.784.868-.067.481-1.832 14.13-1.832 14.13L16.042 24V2.77a1 1 0 0 0-.177.03m-3.381 1.047-2.47.765c.239-.914.69-1.824 1.247-2.42.207-.222.496-.469.838-.61.323.67.392 1.622.385 2.265M10.898.775c.273-.006.503.054.7.184a3.4 3.4 0 0 0-.904.704c-.74.793-1.305 2.025-1.531 3.212l-2.03.628c.4-1.87 1.969-4.676 3.765-4.728M8.633 11.427c.079 1.246 3.356 1.518 3.54 4.436.145 2.296-1.218 3.866-3.181 3.99-2.356.15-3.653-1.242-3.653-1.242l.499-2.124s1.306.985 2.351.92c.683-.044.927-.599.902-.992-.103-1.625-2.771-1.529-2.94-4.2-.142-2.247 1.334-4.524 4.59-4.73 1.255-.079 1.897.241 1.897.241l-.745 2.786s-.831-.378-1.815-.316c-1.444.092-1.459 1.002-1.445 1.231m4.624-7.82c-.01-.589-.08-1.409-.354-2.118.883.167 1.318 1.167 1.502 1.763zM16.527 23.942l6.075-1.51S19.986 4.748 19.97 4.626a.235.235 0 0 0-.21-.196c-.088-.007-1.798-.033-1.798-.033s-1.043-1.013-1.435-1.396z" />
    </g>
    <defs>
      <clipPath id="fi-brands-shopify_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsShopify;
